
toastr.options = {
    "closeButton": true,
    "positionClass": "toast-top-right"
}
